import {
    storeAlvarasRequest,
    updateAlvarasRequest,
    showAlvarasRequest,
} from "@/services/requests/alvaras";

import {
    storeAmbientalRequest,
    updateAmbientalRequest,
    showAmbientalRequest,
} from "@/services/requests/ambiental";

import {
    storeBombeiroRequest,
    updateBombeiroRequest,
    showBombeiroRequest,
} from "@/services/requests/bombeiro";

import {
    storeCertificadoRequest,
    updateCertificadoRequest,
    showCertificadoRequest,
} from "@/services/requests/certificado";

import {
    storeAlvarasSanitarioRequest,
    updateAlvarasSanitarioRequest,
    showAlvarasSanitarioRequest,
} from "@/services/requests/alvarasSanitario";

import {
    storeCoworkingRequest,
    updateCoworkingRequest,
    showCoworkingRequest,
} from '@/services/requests/coworking';

// Assuming the type of document is determined by a 'type' parameter and 'id' is the document's ID.
export async function showDocumento(type, id) {
    let arquivo;
    switch (type) {
        case 'alvara':
            arquivo = await showAlvarasRequest(id)
                .then((response) => response.data.data.arquivo)
                .catch((error) => console.error(error));
            break;
        case 'sanitario':
            arquivo = await showAlvarasSanitarioRequest(id)
                .then((response) => response.data.data.arquivo)
                .catch((error) => console.error(error));
            break;
        case 'bombeiro':
            arquivo = await showBombeiroRequest(id)
                .then((response) => response.data.data.arquivo)
                .catch((error) => console.error(error));
            break;
        case 'ambiental':
            arquivo = await showAmbientalRequest(id)
                .then((response) => response.data.data.arquivo)
                .catch((error) => console.error(error));
            break;
        case 'certificado':
            arquivo = await showCertificadoRequest(id)
                .then((response) => response.data.data.arquivo)
                .catch((error) => console.error(error));
            break;
        case 'coworking':
            arquivo = await showCoworkingRequest(id)
                .then((response) => response.data.data.arquivo)
                .catch((error) => console.error(error));
            break;
        default:
            console.log("Unknown document type.");
            break;
    }
    return arquivo;
}

// Function to store documents based on their type
export async function storeDocumento(type, documentData) {
    let response;
    switch (type) {
        case 'alvara':
            response = await storeAlvarasRequest(documentData)
                .then(res => res.data)
                .catch(error => console.error(error));
            break;
        case 'sanitario':
            response = await storeAlvarasSanitarioRequest(documentData)
                .then(res => res.data)
                .catch(error => console.error(error));
            break;
        case 'bombeiro':
            response = await storeBombeiroRequest(documentData)
                .then(res => res.data)
                .catch(error => console.error(error));
            break;
        case 'ambiental':
            response = await storeAmbientalRequest(documentData)
                .then(res => res.data)
                .catch(error => console.error(error));
            break;
        case 'certificado':
            response = await storeCertificadoRequest(documentData)
                .then(res => res.data)
                .catch(error => console.error(error));
            break;
        case 'coworking':
            response = await storeCoworkingRequest(documentData)
                .then(res => res.data)
                .catch(error => console.error(error));
            break;
        default:
            console.log("Unknown document type for storage.");
            break;
    }
    return response;
}

// Function to update documents based on their type
export async function updateDocumento(type, id, updateData) {
    let response;
    switch (type) {
        case 'alvara':
            response = await updateAlvarasRequest(id, updateData)
                .then(res => res.data)
                .catch(error => console.error(error));
            break;
        case 'sanitario':
            response = await updateAlvarasSanitarioRequest(id, updateData)
                .then(res => res.data)
                .catch(error => console.error(error));
            break;
        case 'bombeiro':
            response = await updateBombeiroRequest(id, updateData)
                .then(res => res.data)
                .catch(error => console.error(error));
            break;
        case 'ambiental':
            response = await updateAmbientalRequest(id, updateData)
                .then(res => res.data)
                .catch(error => console.error(error));
            break;
        case 'certificado':
            response = await updateCertificadoRequest(id, updateData)
                .then(res => res.data)
                .catch(error => console.error(error));
            break;
        case 'coworking':
            response = await updateCoworkingRequest(id, updateData)
                .then(res => res.data)
                .catch(error => console.error(error));
            break;
        default:
            console.log("Unknown document type for update.");
            break;
    }
    return response;
}

